@if (formGroupReference) {
<div [formGroup]="formGroupReference">
  <mat-radio-group formControlName="rootOption" class="form-element-group-column">
    @for (rootOption of optionsTree; track rootOption; let first = $first) {
    <mat-radio-button
      data-testid="radio-tree-filter"
      class="display-block full-width"
      [name]="'rootOption'"
      [id]="rootOption.value"
      [value]="rootOption.value"
    >
      @if (rootOption.childrenOptions.length) {
      <stx-chevron-line
        [isExpanded]="rootOption.visible"
        [showChevron]="showChevron"
        (toggleEvent)="toggleChildrenOptions(rootOption.value)"
      >
        {{ rootOption.label | translate }}
      </stx-chevron-line>
      } @else {
      {{ rootOption.label | translate }}
      }
    </mat-radio-button>
    @if (rootOption.description) {
    <div class="display-block full-width indented-form-block">
      @for (line of rootOption.description; track line) {
      <span class="form-element-secondary-label">
        {{ line | translate }}
      </span>
      }
    </div>
    } @if (rootOption.childrenOptions.length && rootOption.visible) {
    <div class="display-block full-width indented-form-block form-element-group-column force-vt-spacing">
      <stx-radio-group
        @childrenOptions
        [formGroup]="childrenOptionsGroup"
        [layoutDirection]="'column'"
        [options]="rootOption.childrenOptions"
        [controlName]="rootOption.value"
      >
      </stx-radio-group>
    </div>
    } }
  </mat-radio-group>
</div>
}
